module.exports = __webpack_public_path__ + "img/bgc1.fbc54948.png";